class CompiledRegExp {
  constructor(public regexp: RegExp) {}

  test = (value: string): boolean => {
    return new RegExp(this.regexp).test(value)
  }

  exec = (value: string): string[] => {
    const data = new RegExp(this.regexp).exec(value)
    if (data === null) {
      return ['']
    } else {
      return data.slice(1)
    }
  }

  parse = (value: string, format: string): string => {
    return value.replace(new RegExp(this.regexp, 'g'), format)
  }
}

/**
 * 정규식을 사용할 때는 반드시 new RegExp()를 사용해 컴파일을 유도해야 한다.
 * https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/RegExp#%EB%A6%AC%ED%84%B0%EB%9F%AC%EB%8B%9D_%ED%91%9C%EA%B8%B0%EB%B2%95%EA%B3%BC_%EC%83%9D%EC%84%B1%EC%9E%90
 *
 * @see 국내전화번호: https://ko.wikipedia.org/wiki/%EB%8C%80%ED%95%9C%EB%AF%BC%EA%B5%AD%EC%9D%98_%EC%A0%84%ED%99%94%EB%B2%88%ED%98%B8_%EC%B2%B4%EA%B3%84
 */
export default {
  mobileKorean: new CompiledRegExp(/^(01[0987651])(\d{3,4})(\d{4})/g),
  telephoneKoreanRegion: new CompiledRegExp(/^(02|0[3-9]\d?)(\d{3,4})(\d{4})$/g),
  telephoneKoreanNoRegion: new CompiledRegExp(/^(1[568]\d{2})(\d{4})/g)
}
